export const firebaseConfig = {
  apiKey: "AIzaSyC-MDPU5KrC0ycoXQxyzNWRTGyqixalnOc",
  authDomain: "ticket-to-mba.firebaseapp.com",
  databaseURL: "https://ticket-to-mba.firebaseio.com",
  projectId: "ticket-to-mba",
  storageBucket: "ticket-to-mba.appspot.com",
  messagingSenderId: "534434512675",
  appId: "1:534434512675:web:7fc6c987aef7e7da"
};